module.exports = __webpack_public_path__ + "media/images/nanny-signup-c239cef0bfe2c43e87f01badf0d44bc8.jpg";